
/**
 * Type of tweet
 */
export type TweetResponseTweetType = typeof TweetResponseTweetType[keyof typeof TweetResponseTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
